/* eslint-disable no-unused-vars */
import CloseIcon from "@mui/icons-material/Close";
import { LoadingButton } from "@mui/lab";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import { Auth } from "../../api/Channel/Auth";
import CoreInput from "common/components/forms_context/CoreInput";
import { LOCAL_STORAGE, setDataSession } from "helper/session";
import { checkRegexPassword, checkRegexVietnameseAndSpace } from "helper/utils";
import { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import OTP from "./OTP";

const ChangePasswordForm = ({ open, handleClose }) => {
  const form = useForm({ mode: "onChange" });
  const { watch, handleSubmit } = form;

  const { t } = useTranslation("common");
  const { t: tUAA } = useTranslation("uaa");
  const [isShow, setIsShow] = useState(false);

  const { mutateAsync: getOTP, isLoading: isLoadingVerify } = useMutation({
    mutationFn: Auth.sendOTPUsername,
    onSuccess: ({ data }) => {
      const { data: dataSuccess } = data;
      if (!data.hasOwnProperty("errorCodes") && dataSuccess) {
        // dispatch(setIsConfirmUser(true));

        setDataSession(LOCAL_STORAGE, "user", {
          phoneNumber: dataSuccess.phone,
        });
        toast.success(tUAA(`message.get-otp-success`));
      }
    },
  });

  const onSubmit = async (values) => {
    const { userName } = values;
    setIsShow(true);
    await getOTP(userName);
  };

  // const isConfirmUser = useSelector((state) => state.userData.isConfirmUser);

  const handleCloseSuccess = () => {
    setIsShow(false);
    handleClose();
  };

  return (
    <>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>
          <div className="flex items-center justify-between">
            <span>{t("changepassword.label")}</span>
            {handleClose ? (
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            ) : null}
          </div>
        </DialogTitle>
        <DialogContent>
          <FormProvider {...form}>
            <Box className="w-180 my-10">
              <form onSubmit={handleSubmit(onSubmit)} autoComplete="false">
                <CoreInput
                  name="userName"
                  className="w-full mb-10"
                  label={t(`label.username`)}
                  required
                  inputProps={{ maxLength: 20 }}
                  autoFocus
                  rules={{
                    validate: (value) => {
                      if (!!value && checkRegexVietnameseAndSpace(value)) {
                        // return `${tUAA("message.msg-error-not-special", {
                        //   label: t("label.username"),
                        // })}`;
                        return "message.msg-error-not-special";
                      }
                    },
                  }}
                />
                <CoreInput
                  name="oldPassword"
                  className="w-full mb-10"
                  label={t(`label.currentPassword`)}
                  required
                  type="password"
                  inputProps={{ maxLength: 20 }}
                  rules={{
                    validate: (value) => {
                      if (!!value && value.length < 8) {
                        // return `${tUAA("message.msg-error-not-special", {
                        //   label: t("label.currentPassword"),
                        // })}`;
                        return "message.msg-error-not-special";
                      }
                    },
                  }}
                />

                <CoreInput
                  name="newPassword"
                  label={t("password.newPassword")}
                  type="password"
                  placeholder={t("password.placeholder")}
                  className=" mb-10 w-full"
                  required
                  rules={{
                    validate: (value) => {
                      if (!!value) {
                        if (!checkRegexPassword(value)) {
                          // return `${tUAA("message.msg-error-not-special", {
                          //   label: t("password.newPassword"),
                          // })}`;
                          return "message.msg-error-not-special";
                        }
                        if (!value.localeCompare(watch("oldPassword"))) {
                          // return `${tUAA("message.not-repeat-current-pw")}`;
                          return "message.not-repeat-current-pw";
                        }
                      }
                    },
                  }}
                  inputProps={{ maxLength: 15 }}
                />
                <CoreInput
                  name="reNewPassword"
                  label={t("password.confirmPassword")}
                  type="password"
                  placeholder={t("password.placeholder")}
                  className=" mb-10 w-full"
                  required
                  rules={{
                    validate: (value) => {
                      if (!!value) {
                        if (value.localeCompare(watch("newPassword"))) {
                          // return `${tUAA("message.not-match-password")}`;
                          return "message.not-match-password";
                        }
                        if (!value.localeCompare(watch("oldPassword"))) {
                          // return `${tUAA("message.not-repeat-current-pw")}`;
                          return "message.not-repeat-current-pw";
                        }
                      }
                    },
                  }}
                  inputProps={{ maxLength: 15 }}
                />

                <div>
                  <span>{tUAA(`label.rule-password`)}:</span>
                  <ul>
                    <li>{tUAA(`label.character-number`)}</li>
                    <li>{tUAA(`label.min-character`, { length: 8 })}</li>
                    <li>{tUAA(`label.not-space`)}</li>
                    {/* <li>{tUAA(`label.not-contain-username`)}</li> */}
                  </ul>
                  <i>{tUAA(`label.ex-password`)}</i>
                </div>

                <div className="text-right mt-5">
                  <LoadingButton
                    variant="contained"
                    className="py-6 px-12 h-21"
                    type="submit"
                    // loading={isLoadingVerify}
                  >
                    {`${t(`btn.change`)}`}
                  </LoadingButton>
                </div>
              </form>
            </Box>
            {isShow ? (
              <OTP
                isShowModal={isShow}
                isChangePassword={true}
                handleCloseModal={() => setIsShow(false)}
                handleCloseSuccess={handleCloseSuccess}
                getOTP={getOTP}
              />
            ) : null}
          </FormProvider>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ChangePasswordForm;
